import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";

export default function FeaturedSection() {
  const featured = articles.filter((item) => item.featured).slice(0, 4);
  const [lead, ...rest] = featured;

  return (
    <section className="border-y border-background-800 bg-background-900/60">
      <div className="mx-auto w-full max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs tracking-[0.3em] text-accent-300">EDITOR&apos;S PICK</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">编辑精选长文</h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-400">
              资料完整、线索交错的四篇深度档案。建议留出完整的时间，按顺序读完整个时间线。
            </p>
          </div>
          <span className="flex w-fit items-center gap-2 rounded-full border border-background-700 px-3 py-1.5 text-xs text-foreground-400">
            <i className="ri-fire-line text-accent-400" /> 本周高热
          </span>
        </div>

        {lead && (
          <div className="mt-8">
            <ArticleCard article={lead} variant="wide" />
          </div>
        )}

        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}